var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSingleSchedule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "schedule-group-single-icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 11C13.5069 11 13.9719 11.4477 13.9988 12.0107L14 12.0622V12.25C14 13.1889 13.5146 13.8917 12.7699 14.345C12.0377 14.7908 11.0535 15 10 15C8.94652 15 7.96227 14.7908 7.23005 14.345C6.50798 13.9055 6.02966 13.2312 6.00133 12.3347L6 12.25V12.0622C6 11.4926 6.44824 11.0281 7.01101 11.0012L7.06247 11H12.9375ZM10 5C11.3807 5 12.5 6.11929 12.5 7.5C12.5 8.8807 11.3807 10 10 10C8.6193 10 7.5 8.8807 7.5 7.5C7.5 6.11929 8.6193 5 10 5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleSchedule);
export default __webpack_public_path__ + "static/media/single_schedule.b77ffc56b3fe9ca6bd5a4ce6b8b88610.svg";
export { ForwardRef as ReactComponent };